<template>
  <el-dialog :title="industry ? industry.bd_name : ''" :visible="active && !!industry" custom-class="hk-industry-dialog market-board-dialog" width="min(620px, 90vw)" top="10vh" append-to-body @close="$emit('close')">
    <div class="hk-industry-stocks home-quotes-scroll">
      <table class="home-quotes-table">
        <thead><tr><th scope="col">代码</th><th scope="col">名称</th><th scope="col">最新价</th><th scope="col">涨跌幅</th></tr></thead>
        <tbody>
          <tr v-for="item in sharedStockRows(stocks, 'hk')" :key="item.code" tabindex="0" @click="$emit('select-stock', item)" @keydown.enter="$emit('select-stock', item)">
            <td>{{ item.code }}</td><td>{{ item.prod_name }}</td><td>{{ price(item.last_px) }}</td>
            <td :class="Number(item.px_change_rate) > 0 ? 'rise' : Number(item.px_change_rate) < 0 ? 'fall' : ''">{{ percent(item.px_change_rate) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="loading" class="dialog-state" role="status">加载中…</div>
      <div v-else-if="error" class="dialog-state" role="alert">{{ error }} <button type="button" @click="load">重试</button></div>
      <div v-else-if="!stocks.length" class="dialog-state">暂无行业股票数据</div>
    </div>
  </el-dialog>
</template>

<script>
import { quotePercent } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import { getHongKongIndustryStocks } from '../api'
import { pollMarket } from '@/utils/marketRefresh'
import { getStockQuotes } from '@/utils/stockQuotes'
import { quoteNumber, quotePrice } from '@/utils/quoteDisplay'

export default {
  name: 'HongKongIndustryDialog',
  props: { industry: { type: Object, default: null }, active: { type: Boolean, default: true } },
  data() { return { stocks: [], loading: false, error: '', requestId: 0 } },
  watch: {
    industry() { this.stopPolling(); if (this.industry) this.activate(); else { this.requestId++; this.stocks = [] } },
    active(value) { if (value) this.activate(); else this.stopPolling() }
  },
  mounted() { if (this.active && this.industry) this.activate() },
  beforeDestroy() { this.disposed = true; this.requestId++; this.stopPolling() },
  methods: {
    price: quotePrice,
    sharedStockRows,
    stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
    async activate() {
      if (this.disposed || !this.active || !this.industry || this.stopRefresh) return
      try { await this.load() }
      finally {
        if (!this.disposed && this.active && this.industry && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.refreshMarket(), 'hk')
      }
    },
    async refreshMarket() {
      if (this.disposed || !this.active || !this.industry || this.loading || !this.stocks.length) return
      const requestId = this.requestId, code = this.industry.bd_code
      const codeOf = item => {
        const value = String(item.full_code || item.code || '').toLowerCase()
        return value.startsWith('hk') ? value : 'hk' + value
      }
      const codes = [...new Set(this.stocks.map(codeOf).filter(value => /^hk\d{5}$/.test(value)))]
      if (!codes.length) return
      const quotes = await getStockQuotes(codes.join(','))
      if (requestId !== this.requestId || !this.active || !this.industry || code !== this.industry.bd_code) return
      // Keep the constituent list/order until the next open; only refresh its quotes.
      this.stocks = this.stocks.map(item => {
        const quote = quotes[codeOf(item)]
        if (!Array.isArray(quote) || !(quoteNumber(quote[3]) > 0)) return item
        return { ...item, prod_name: quote[1] || item.prod_name, last_px: quote[3], px_change_rate: quoteNumber(quote[32]) == null ? item.px_change_rate : quote[32] }
      })
    },
    percent: quotePercent,
    async load() {
      if (this.disposed || !this.active || !this.industry) return
      const requestId = ++this.requestId
      this.stocks = []
      this.error = ''
      this.loading = false
      if (!this.industry) return
      if (!this.industry.bd_code || this.industry.bd_code === '--') {
        this.error = '行业代码缺失，暂时无法加载。'
        return
      }
      this.loading = true
      try {
        const stocks = await getHongKongIndustryStocks(this.industry.bd_code)
        if (requestId !== this.requestId) return
        if (!Array.isArray(stocks)) throw new Error('invalid response')
        this.stocks = stocks
      } catch (error) {
        if (requestId === this.requestId) this.error = '行业股票加载失败，请重试。'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>
